<div class="wrapper-header">
    <h2><ng-content></ng-content></h2>
    <button *ngIf="isEditButtonVisible$ | ngrxPush" type="button" class="button-secondary" (click)="edit.emit()">
        <dtm-ui-icon [name]="(icon$ | ngrxPush) ?? 'edit'"></dtm-ui-icon>
        {{ (buttonLabel$ | ngrxPush) ?? ("dtmUi.editableHeader.editButtonLabel" | transloco) }}
    </button>
    <ng-content select="[additionalActions]"></ng-content>
</div>
